// index.js or App.js
import styled from 'styled-components';
import WarningRounded from '../svgIcons/WarningRounded';
import { Elements } from '@stripe/react-stripe-js';
import AddPaymentMethodForm from '../Stripe/AddPaymentMethodForm';
import { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { useFetchPaymentMethodsQuery } from '../../../features/billing/BillingApiSlice';

// SubscriptionAlert.js

const AlertWarning = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #b30000;
  width: 93%;
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  border-color: #ffeeba;
  border-radius: 0.25rem;
  padding: 0.75rem 1.25rem;
  margin-top: 10px;
  font-size: 16px;
`;

const SubscriptionAlert = ({
  subscriptionDetails = {},
  refetchPreLiveChecks,
}) => {
  const { refetch: refetchPaymentMethods } = useFetchPaymentMethodsQuery(null, {
    refetchOnMountOrArgChange: true,
  });

  const [stripePromise] = useState(() =>
    loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY),
  );

  const fetchData = () => {
    refetchPaymentMethods();
    refetchPreLiveChecks();
  };
  return (
    <>
      {subscriptionDetails?.paymentStatus === 'payment_failed' && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '16px',
            justifyContent: 'center',
            marginTop: '10px',
          }}
        >
          <AlertWarning
            role="alert"
            style={{
              textAlign: 'center',
              color: '#b30000',
              width: '93%',
              display: 'flex',
              gap: '5px',
            }}
          >
            <WarningRounded size={18} /> {subscriptionDetails?.paymentMessage}{' '}
            <Elements stripe={stripePromise}>
              <AddPaymentMethodForm
                afterSubmit={fetchData}
                customElement={
                  <span
                    style={{
                      cursor: 'pointer',
                      textDecoration: 'underline',
                    }}
                  >
                    Update Payment Method
                  </span>
                }
              />
            </Elements>
          </AlertWarning>
        </div>
      )}
    </>
  );
};

export default SubscriptionAlert;
